import { render, staticRenderFns } from "./ModalAddUserType.vue?vue&type=template&id=388b6194&"
import script from "./ModalAddUserType.vue?vue&type=script&lang=js&"
export * from "./ModalAddUserType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports